<template>
  <ul-page fullBody class="course-file" v-loading="loading">
    <template v-slot:left>
      <div class="page-header-right">
        <span class="title">{{ archives.studentName }}的课程档案</span>
      </div>
    </template>
    <template v-slot:right>
      <div class="page-header-right">
        <ul-button type="primary" @click="exportPdf">导出</ul-button>
        <ul-button @click="close">关闭</ul-button>
      </div>
    </template>
    <div class="body-content" ref="bodyContent">
      <div class="info">
        <div class="name">
          {{ archives.studentName }}
          <div>的课程档案</div>
        </div>
        <div class="info-ul">
          <ul>
            <li>学号：{{ archives.studentId }}</li>
            <li>性别：{{ archives.sex == 1 ? '男' : archives.sex == 2 ? '女' : '' }}</li>
            <li>注册时间：{{ archives.registerDate | formatDate}}</li>
            <li>邮箱：{{ archives.mail }}</li>
            <li>手机号码：{{ archives.cellphone }}</li>
          </ul>
        </div>
        <div class="info-ul">
          <ul>
            <li>正在学习<span>{{ textbookNum }}</span>门课程</li>
            <li>提交了<span>{{ homeworkNnm }}</span>次作业</li>
            <li>参加了<span>{{ examNum }}</span>场考试</li>
            <li>发布了<span>{{ archives.discussionCount }}</span>个话题，<span>{{ archives.postCount }}</span>条回复</li>
          </ul>
        </div>
      </div>
      <div>
        <div class="subtitle">课程学习记录</div>
        <ul-table :data="archives.textbookList">
          <ul-table-column
            prop="name"
            label="课件名称">
          </ul-table-column>
          <ul-table-column
            label="进度">
            <template slot-scope="scope">
              <span class="bcc-degree">{{ scope.row.progress }}%</span>
            </template>
          </ul-table-column>
          <ul-table-column
            label="学习时长">
            <template slot-scope="scope">
              {{ scope.row.studyTime | formatSeconds }}
            </template>
          </ul-table-column>
          <ul-table-column
            label="最后学习时间">
            <template slot-scope="scope">
              {{ scope.row.lastStudyTime | formatDateHH }}
            </template>
          </ul-table-column>
          <ul-table-column
            prop="score"
            label="分数">
          </ul-table-column>
        </ul-table>
      </div>
      <div>
        <div class="subtitle">
          作业记录
          <span>参与作业次数/作业总数:{{ homeworkNnm }}/{{ archives.homeworkList ? archives.homeworkList.length : 0 }}</span>
        </div>
        <ul-table :data="archives.homeworkList">
          <ul-table-column label="作业名称">
            <template slot-scope="scope">
              <span :class="{'gray': scope.row.status == 9}">{{ scope.row.name }}</span>
            </template>
          </ul-table-column>
          <ul-table-column label="状态">
            <template slot-scope="scope">
              状态：
              <span class="bch-benone">{{ scope.row.status != 9 && scope.row.status != 0 ? '已提交' : '未提交' }}</span>
            </template>
          </ul-table-column>
          <ul-table-column label="成绩">
            <template slot-scope="scope">
              成绩：{{ scope.row.status != 9 && scope.row.status != 0 ? scope.row.score || scoreMpa(scope.row.status) : '--' }}
            </template>
          </ul-table-column>
        </ul-table>
      </div>
      <div>
        <div class="subtitle">
          考试记录
          <span>参与考试次数/考试总数:{{ examNum }}/{{ archives.examList ? archives.examList.length : 0 }}</span>
        </div>
        <ul-table :data="archives.examList">
          <ul-table-column label="考试名称">
            <template slot-scope="scope">
              <span :class="{'gray': scope.row.status == 2}">{{ scope.row.name }}</span>
            </template>
          </ul-table-column>
          <ul-table-column label="状态">
            <template slot-scope="scope">
              状态：
              <span class="bch-benone">{{ scope.row.status == 1 ? '已提交' : '未提交' }}</span>
            </template>
          </ul-table-column>
          <ul-table-column label="成绩">
            <template slot-scope="scope">
              成绩：{{ scope.row.status == 1 ? scope.row.score || scope.row.score == 0 ? scope.row.score: '--' : '--' }}
            </template>
          </ul-table-column>
        </ul-table>
      </div>
    </div>
  </ul-page>
</template>

<script>
import { archives } from '@/api/courseApi'
import { mapGetters } from 'vuex'
import { formatDate, formatSeconds } from '@/utils'
import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'
export default {
  name: 'courseFile',
  data () {
    return {
      ocId: this.$route.query.ocId,
      stuId: this.$route.query.stuId || null,
      archives: {},
      homeworkNnm: 0,
      examNum: 0,
      textbookNum: 0,
      loading: true,
    }
  },
  created () {
    let data = {
      studentUserId: this.stuId,
      ocId: this.ocId
    }
    archives(data)
    .then(res => {
      this.archives = res.result
      this.num()
      this.loading = false
    })
  },
  computed: {
    ...mapGetters({'account': 'user/user'}),
  },
  filters: {
    formatDate(date) {
      return formatDate(date, 'yyyy-MM-dd')
    },
    formatDateHH(date) {
      return formatDate(date)
    },
    formatSeconds(second) {
      return formatSeconds(second)
    }
  },
  methods: {
    scoreMpa(type) {
      let score = ''
      switch (type) {
        case 0:
          score = '未提交'
          break;
        case 1:
          score = '互评未开始'
          break;
        case 2:
          score = '互评中'
          break;
        case 3:
          score = '待批阅'
          break;
        case 5:
          score = '需重写'
          break;
        case 6:
        case 7:
        case 8:
          score = '申诉中'
          break;
        case 10:
          score = '无学生评价'
          break;
        case 12:
          score = '成绩未公布'
          break;
        default:
          score = 0
          break;
      }
      return score
    },
    num() {
      this.homeworkNnm = 0
      this.examNum = 0
      this.textbookNum = 0
      this.archives.homeworkList = this.archives.homeworkList || []
      this.archives.examList = this.archives.examList || []
      this.archives.textbookList = this.archives.textbookList || []
      this.archives.homeworkList.forEach(item => {
        if (item.status != 9 && item.status != 0) {
          this.homeworkNnm++
        }
      })
      this.archives.examList.forEach(item => {
        if (item.status == 1) {
          this.examNum++
        }
      })
      this.archives.textbookList.forEach(item => {
        if (item.studyTime > 0) {
          this.textbookNum++
        }
      })
    },
    exportPdf() {
      let bodyContent = this.$refs.bodyContent
      html2canvas(bodyContent).then(canvas => {
        var contentWidth = canvas.width;
        var contentHeight = canvas.height;
        //一页pdf显示html页面生成的canvas高度;
        var pageHeight = contentWidth / 592.28 * 841.89;
        //未生成pdf的html页面高度
        var leftHeight = contentHeight;
        //页面偏移
        var position = 0;
        //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
        var imgWidth = 555.28;//595.28//左右边距20
        var imgHeight = 552.28/contentWidth * contentHeight;//左右边距20
        var pageData = canvas.toDataURL('image/jpeg', 1.0);
        let pdf = new jsPDF('p', 'pt')
        //有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89)
        //当内容未超过pdf一页显示的范围，无需分页
        if (leftHeight < pageHeight) {
          pdf.addImage(pageData, 'JPEG', 20, 0, imgWidth, imgHeight );//左右边距20
        } else {
          while(leftHeight > 0) {
            pdf.addImage(pageData, 'JPEG', 20, position, imgWidth, imgHeight)//左右边距20
            leftHeight -= pageHeight;
            position -= 841.89;
            //避免添加空白页
            if(leftHeight > 0) {
              pdf.addPage();
            }
          }
        }
        pdf.save(`${this.archives.studentName}的课程档案.pdf`)
      })
    },
    close() {
      window.close()
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  font-size: 18px;
  font-weight: bold;
}
::v-deep.course-file {
  .ul-page__body-content {
    width: 980px !important;
  }
  .body-content {
    margin: 20px auto;
    padding: 20px;
    &>div {
      margin-bottom: 20px;
      border: 1px solid #d1d1d1;
      border-bottom: none;
    }
    .info {
      padding: 20px;
      background: #f3f3f3;
      border: none;
      display: flex;
      .name {
        font-size: 20px;
      }
      .info-ul {
        border-left: 1px solid #d1d1d1;
        ul > li {
          margin-bottom: 15px;
          &>span {
            color: #FF0000;
          }
        }
      }
      &>div {
        padding: 0px 40px;
      }
    }
    .subtitle {
      padding: 10px;
      background: #f3f3f3;
      font-weight: bold;
      span {
        margin-left: 30px;
      }
    }
  }
}
.bcc-degree {
  color: #0fcf0f;
}
.bch-benone {
  color: #ff6868;
}
.gray {
  color: #969696;
}
</style>